import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {useParams} from "react-router";
import {Loader} from "../../components/ui";
import {YearCalendar} from "./year-calendar";
import {DayOffUserStore} from "./store/day-off-user-store";
import {DayOffModal} from "./day-off-modal";
import {useStore} from "../../context";
import {DayOffStatistics} from "./day-off-statistics";
import './days-off-manage-user.css';

export const DaysOffManageUser = observer(() => {
    const { userId } = useParams<{ userId: string }>();
    const { uiBus } = useStore();
    const [store] = useState(() => new DayOffUserStore(uiBus))

    useEffect(() => {
        store.loadUserDaysOff(userId);
    }, [userId]);

    if (store.isLoading || !store.daysOffForUser) {
        return <Loader/>
    }

    return <div className={'dashboard days-off-manage-user'}>
        <YearCalendar store={store}/>
        <DayOffStatistics store={store}/>
        {store.isDayOffModalOpen && <DayOffModal store={store}/>}
    </div>
})
